import Form, { FormInstance } from 'antd/lib/form';
import { UploadChangeParam, UploadFile } from 'antd/lib/upload/interface';
import React, { useEffect, useState } from 'react';
import { ISubjPrilozenesoubory } from 'types/amlz';

import Paragraph from 'components/atoms/Paragraph';
import UploadComponent, { IFileList } from 'components/atoms/UploadComponent';
import TranslateText from 'components/hoc/TranslateText';

import fileDownload from 'services/fileDownload';
import { prepareFileAmlz } from 'services/prepareFile';
import { EStavZadostAmlz } from 'services/spravaEmitenta/historickeZadosti';
import { EZadostPravoIdentifikace, ISubjPravo, certKontrolaSmsApi } from 'services/spravaEmitenta/zadostPravo';
import { ICertKontrolaResp, certKontrolaApi } from 'services/spravaUzivatelu/uzivatele';

import { EDownloadingStatus } from 'enums/amlz/downloadingStatus';
import { ETypSouboru } from 'enums/amlz/typSouboru';
import { EZastupujeOsoba } from 'enums/amlz/zastupujeOsoba';
import apiPaths from 'enums/apiPaths';

export const UploadPropsStateHolder = (
    personData: ISubjPravo | undefined,
    idZadosti: number | undefined,
    mode: 'smsLogin' | 'zadostOOsoby' | 'zadostOAmlz' | 'zadostEdit' | 'C2' | 'displayOnly',
    form: FormInstance,
    idOsoby: number | undefined,
    setPdfCheckError: React.Dispatch<React.SetStateAction<string>>,
    isAmlzRequired?: boolean
) => {
    const [potvrzeniFileList, setPotvrzeniFileList] = useState<IFileList[]>([]);
    const [potvrzeniSoubory, setPotvrzeniSoubory] = useState<ISubjPrilozenesoubory[]>([]);
    const [fileList, setFileList] = useState<IFileList[]>([]);
    const [zasOsobaFileList, setZasOsobaFileList] = useState<IFileList[]>([]);
    const [zasOsobaSoubory, setZasOsobaSoubory] = useState<ISubjPrilozenesoubory[]>([]);
    const [dokladyTotozFileList, setDokladyTotozFileList] = useState<IFileList[]>([]);
    const [dokladyTotozSoubory, setDokladyTotozSoubory] = useState<ISubjPrilozenesoubory[]>([]);
    const [elPodpisFileList, setElPodpisFileList] = useState<IFileList[]>([]);
    const [elPodpisSoubor, setElPodpisSoubor] = useState<ISubjPrilozenesoubory[]>([]);
    const [showCertErr, setShowCertErr] = useState<boolean>(false);
    const [downloading, setDownloading] = useState<string>('');
    const [certUploadResp, setCertUploadResp] = useState<ICertKontrolaResp>();
    const [showZastupujeUpload, setShowZastupujeUpload] = useState<string>('');
    const [showIdentifikaceUpload, setShowIdentifikaceUpload] = useState<string>('');
    const [uploadStateReady, setUploadStateReady] = useState<boolean>(false);
    const [disableDownloadPotvrzeni, setDisableDownloadPotvrzeni] = useState<boolean>(false);
    const identifikaceOsobyElhasFileUploaded =
        mode === 'displayOnly' ||
        (showIdentifikaceUpload === EZadostPravoIdentifikace.EL &&
            !!elPodpisFileList.length &&
            (mode === 'zadostEdit' || mode === 'C2' ? isAmlzRequired : true));

    useEffect(() => {
        // setnutie dat upload componentov pri prvotnom nacitani
        if (personData?.prilozenesoubory) {
            const plnaMoc = personData.prilozenesoubory?.filter(
                e => e.oblast === ETypSouboru.SOUBOR_PLNAMOC || e.oblast === ETypSouboru.SOUBOR_JINASMLOUVA
            );
            const dokladTotoz = personData.prilozenesoubory?.filter(e => e.oblast === ETypSouboru.SOUBOR_DOKLAD);
            const podepsanySoubor = personData.prilozenesoubory?.filter(
                e => e.oblast === ETypSouboru.SOUBOR_PODEPSANYSOUBOR
            );
            const potvrzeniSoubor = personData.prilozenesoubory.filter(e => e.oblast === ETypSouboru.SOUBOR_UCET);

            setDokladyTotozSoubory(dokladTotoz ? dokladTotoz : []);
            setZasOsobaSoubory(plnaMoc ? plnaMoc : []);
            setElPodpisSoubor(podepsanySoubor ? podepsanySoubor : []);
            setPotvrzeniSoubory(potvrzeniSoubor ? potvrzeniSoubor : []);
            setPotvrzeniFileList(
                potvrzeniSoubor?.map((e, i) => {
                    return {
                        uid: String(i),
                        name: e.orignazev ? e.orignazev : 'bez nazvu',
                        fileName: e.tempnazev ? e.tempnazev : 'a',
                        type: e.orignazev ? e.orignazev.split('.').slice(-1)[0] : '',
                        size: 0,
                        status: 'done'
                    };
                })
            );
            setDokladyTotozFileList(
                dokladTotoz?.map((e, i) => {
                    return {
                        uid: String(i),
                        name: e.orignazev ? e.orignazev : 'bez nazvu',
                        fileName: e.tempnazev ? e.tempnazev : 'a',
                        type: e.orignazev ? e.orignazev.split('.').slice(-1)[0] : '',
                        size: 0,
                        status: 'done'
                    };
                })
            );
            setZasOsobaFileList(
                plnaMoc?.map((e, i) => {
                    return {
                        uid: String(i),
                        name: e.orignazev ? e.orignazev : 'bez nazvu',
                        fileName: e.tempnazev ? e.tempnazev : 'a',
                        type: e.orignazev ? e.orignazev.split('.').slice(-1)[0] : '',
                        size: 0,
                        status: 'done'
                    };
                })
            );
            setElPodpisFileList(
                podepsanySoubor?.map((e, i) => {
                    return {
                        uid: String(i),
                        name: e.orignazev ? e.orignazev : 'bez nazvu',
                        fileName: e.tempnazev ? e.tempnazev : 'a',
                        type: e.orignazev ? e.orignazev.split('.').slice(-1)[0] : '',
                        size: 0,
                        status: 'done'
                    };
                })
            );
            setShowIdentifikaceUpload(personData.identifikaceosoby ? personData.identifikaceosoby : '');
            setShowZastupujeUpload(personData.zastupuje ? personData.zastupuje : '');
            podepsanySoubor?.length && setShowIdentifikaceUpload(personData.identifikaceosoby || ''); // zobrazi upload componentu
            setTimeout(() => {
                setUploadStateReady(true);
            }, 200);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const uploadPropsPotvrzeni = {
        id: 'potvrzeniDownloadBtn',
        showDownloadIcon: true,
        onChange: (data: UploadChangeParam) => {
            if (data.file.status === 'uploading') setDownloading('potvrzeni');
            if (data.file.status !== 'uploading') setDownloading('');

            if (data.file.response && data.fileList.length) {
                setPotvrzeniSoubory(
                    data.fileList
                        .filter(f => f.status && f.status !== 'error')
                        .map(e => {
                            return {
                                orignazev: e.name.normalize(),
                                tempnazev: e.response ? e.response.tempnazev : e.fileName,
                                oblast: ETypSouboru.SOUBOR_UCET
                            };
                        })
                );
            }

            data.fileList &&
                (setPotvrzeniFileList(
                    data.fileList
                        .filter(f => f.status && f.status !== 'error')
                        .map(e => {
                            return {
                                uid: e.uid,
                                name: e.name.normalize(),
                                fileName: e.fileName ? e.fileName : e.response ? e.response.tempnazev : '',
                                type: e.type!,
                                size: e.size!,
                                status: e.status ? e.status : 'error'
                            };
                        })
                ),
                form.validateFields(['potvrzeni']));
            if (data.file.status === 'done') setDownloading('');
        },
        onRemove: (file: UploadFile) => {
            if (potvrzeniFileList?.length) {
                const oldState = [...potvrzeniFileList];
                const newState = oldState.filter(e => e.uid !== file.uid);
                setPotvrzeniFileList(newState);
                const newSoubory = [...potvrzeniSoubory].filter(e => e.tempnazev !== file.fileName);
                setPotvrzeniSoubory(newSoubory);
            }
        },
        onDownload: (file: UploadFile) =>
            prepareFileAmlz(idZadosti!, file.fileName ? file.fileName : '', mode === 'smsLogin', idOsoby).then(resp => {
                setDownloading('potvrzeni');
                fileDownload(
                    resp.redirect,
                    file.name ? file.name : 'file',
                    mode === 'smsLogin' ? 'AMLodkaz/Download' : null
                ).finally(() => setDownloading(''));
            }),
        fileList: potvrzeniFileList,
        buttonDisabled: mode === 'displayOnly' || potvrzeniFileList ? potvrzeniFileList.length > 0 : false,
        buttonLoading: downloading === 'potvrzeni'
    };

    const RenderCertUpload = () => {
        return (
            <div>
                <Form.Item
                    style={{
                        marginTop: 16,
                        marginBottom: 16
                    }}
                    id="potvrzeni"
                    name="potvrzeni"
                    label={<Paragraph text={'POTVRZENI_PLATBY'} strong={true} />}
                    rules={[
                        {
                            validator() {
                                try {
                                    if (!potvrzeniSoubory?.length)
                                        return Promise.reject(
                                            <TranslateText>NEVALIDNI_POVINNA_POLOZKA_UPLOAD</TranslateText>
                                        );
                                    return Promise.resolve();
                                } catch {
                                    return Promise.reject();
                                }
                            }
                        }
                    ]}
                >
                    <div
                        style={{
                            marginBottom: 22
                        }}
                    >
                        <UploadComponent
                            {...uploadPropsPotvrzeni}
                            showRemoveIcon={
                                !(
                                    mode === 'displayOnly' ||
                                    identifikaceOsobyElhasFileUploaded ||
                                    form.getFieldValue('stav') === EStavZadostAmlz.HOTOVO ||
                                    form.getFieldValue('stav') === EStavZadostAmlz.HOTOVOIIS ||
                                    form.getFieldValue('stav') === EStavZadostAmlz.CDCPKEKONTR ||
                                    ((mode === 'C2' || mode === 'zadostEdit') && !isAmlzRequired)
                                )
                            }
                            hideButton={
                                mode === 'displayOnly' ||
                                identifikaceOsobyElhasFileUploaded ||
                                form.getFieldValue('stav') === EStavZadostAmlz.HOTOVO ||
                                form.getFieldValue('stav') === EStavZadostAmlz.HOTOVOIIS ||
                                form.getFieldValue('stav') === EStavZadostAmlz.CDCPKEKONTR ||
                                ((mode === 'C2' || mode === 'zadostEdit') && !isAmlzRequired)
                            }
                            uploadPath={mode === 'smsLogin' ? apiPaths.FILE_UPLOAD_AMLODKAZ : ''}
                            beforeUpload={() => !disableDownloadPotvrzeni}
                            onButtonClick={() => {
                                form.validateFields(['cislouctu', 'banka'])
                                    .then(() => setDisableDownloadPotvrzeni(false))
                                    .catch(() => setDisableDownloadPotvrzeni(true));
                            }}
                        />
                    </div>
                </Form.Item>
            </div>
        );
    };
    const uploadPropsZastupujiciOsoba = {
        id: 'c2PlnaMocDownloadBtn',
        showDownloadIcon: true,
        onChange: (data: UploadChangeParam) => {
            if (data.file.status === 'uploading') setDownloading('zastupOsoba');
            if (data.file.status !== 'uploading') setDownloading('');

            if (data.file.response && data.fileList.length) {
                setZasOsobaSoubory(
                    data.fileList
                        .filter(f => f.status && f.status !== 'error')
                        .map(e => {
                            return {
                                orignazev: e.name.normalize(),
                                tempnazev: e.response ? e.response.tempnazev : e.fileName,
                                oblast:
                                    showZastupujeUpload == EZastupujeOsoba.FYZOSOBA_PLNAMOC
                                        ? ETypSouboru.SOUBOR_PLNAMOC
                                        : ETypSouboru.SOUBOR_JINASMLOUVA
                            };
                        })
                );
            }

            data.fileList &&
                (setZasOsobaFileList(
                    data.fileList
                        .filter(f => f.status && f.status !== 'error')
                        .map(e => {
                            return {
                                uid: e.uid,
                                name: e.name.normalize(),
                                fileName: e.fileName ? e.fileName : e.response ? e.response.tempnazev : '',
                                type: e.type!,
                                size: e.size!,
                                status: e.status ? e.status : 'error'
                            };
                        })
                ),
                form.validateFields(['soubor']));
            if (data.file.status === 'done') setDownloading('');
        },
        onRemove: (file: UploadFile) => {
            if (zasOsobaFileList?.length) {
                const oldState = [...zasOsobaFileList];
                const newState = oldState.filter(e => e.uid !== file.uid);
                setZasOsobaFileList(newState);
                const newSoubory = [...zasOsobaSoubory].filter(e => e.tempnazev !== file.fileName);
                setZasOsobaSoubory(newSoubory);
            }
        },
        onDownload: (file: UploadFile) =>
            prepareFileAmlz(idZadosti!, file.fileName ? file.fileName : '', mode === 'smsLogin', idOsoby).then(resp => {
                setDownloading('zastupOsoba');
                fileDownload(
                    resp.redirect,
                    file.name ? file.name : 'file',
                    mode === 'smsLogin' ? 'AMLodkaz/Download' : null
                ).finally(() => setDownloading(''));
            }),
        fileList: zasOsobaFileList,
        buttonDisabled: zasOsobaFileList ? zasOsobaFileList.length > 4 : false
    };
    const RenderZastupujiciOsobaUpload = () => (
        <Form.Item
            id="soubor"
            name="soubor"
            style={{
                marginBottom: 0,
                position: 'relative',
                top: -8
            }}
            rules={[
                {
                    validator() {
                        try {
                            if (!zasOsobaFileList?.length)
                                return Promise.reject(<TranslateText>NEVALIDNI_POVINNA_POLOZKA_UPLOAD</TranslateText>);
                            return Promise.resolve();
                        } catch {
                            return Promise.reject();
                        }
                    }
                }
            ]}
        >
            <div
                style={{
                    marginBottom: 22
                }}
            >
                <Paragraph
                    style={{
                        display: 'block',
                        marginBottom: 4
                    }}
                    text={
                        showZastupujeUpload == EZastupujeOsoba.FYZOSOBA_PLNAMOC
                            ? form.getFieldValue('stav') === EStavZadostAmlz.HOTOVO ||
                              form.getFieldValue('stav') === EStavZadostAmlz.HOTOVOIIS
                                ? 'FORMULARE_PLNA_MOC_DISABLED'
                                : 'FORMULARE_PLNA_MOC'
                            : showZastupujeUpload == EZastupujeOsoba.FYZOSOBA_JINEOPRAV
                              ? form.getFieldValue('stav') === EStavZadostAmlz.HOTOVO ||
                                form.getFieldValue('stav') === EStavZadostAmlz.HOTOVOIIS
                                  ? 'FORMULARE_JINE_OPRAVNENI_DISABLED'
                                  : 'FORMULARE_JINE_OPRAVNENI'
                              : ''
                    }
                />
                <UploadComponent
                    {...uploadPropsZastupujiciOsoba}
                    showRemoveIcon={
                        !(
                            mode === 'displayOnly' ||
                            form.getFieldValue('stav') === EStavZadostAmlz.HOTOVO ||
                            form.getFieldValue('stav') === EStavZadostAmlz.CDCPKEKONTR ||
                            form.getFieldValue('stav') === EStavZadostAmlz.HOTOVOIIS
                        )
                    }
                    hideButton={
                        mode === 'displayOnly' ||
                        form.getFieldValue('stav') === EStavZadostAmlz.HOTOVO ||
                        form.getFieldValue('stav') === EStavZadostAmlz.CDCPKEKONTR ||
                        form.getFieldValue('stav') === EStavZadostAmlz.HOTOVOIIS
                    }
                    uploadPath={mode === 'smsLogin' ? apiPaths.FILE_UPLOAD_AMLODKAZ : ''}
                />
            </div>
        </Form.Item>
    );

    const uploadPropsKopieDokladouTotoznosti = {
        id: 'c2DokladTotoznostiBtn',
        showDownloadIcon: true,
        onChange: (data: UploadChangeParam) => {
            if (data.file.status === 'uploading') setDownloading('dokladTotoz');
            if (data.file.status !== 'uploading') setDownloading('');

            if (data.file.response && data.fileList.length) {
                setDokladyTotozSoubory(
                    data.fileList
                        .filter(f => f.status && f.status !== 'error')
                        .map(e => {
                            return {
                                orignazev: e.name.normalize(),
                                tempnazev: e.response ? e.response.tempnazev : e.fileName,
                                oblast: ETypSouboru.SOUBOR_DOKLAD
                            };
                        })
                );
            }
            setDokladyTotozFileList(
                data.fileList
                    .filter(f => f.status && f.status !== 'error')
                    .map(e => {
                        return {
                            uid: e.uid,
                            name: e.name.normalize(),
                            fileName: e.fileName ? e.fileName : e.response ? e.response.tempnazev : '',
                            type: e.type!,
                            size: e.size!,
                            status: e.status ? e.status : 'error'
                        };
                    })
            );

            if (data.file.status === 'done') {
                setDownloading('');
                form.validateFields(['sc']);
            }
        },
        onRemove: (file: UploadFile) => {
            if (dokladyTotozFileList?.length) {
                const oldState = [...dokladyTotozFileList];
                const newState = oldState.filter(e => e.uid !== file.uid);
                setDokladyTotozFileList(newState);
                const newSoubory = [...dokladyTotozSoubory].filter(e => e.tempnazev !== file.fileName);
                setDokladyTotozSoubory(newSoubory);
            }
        },
        onDownload: (file: UploadFile) =>
            prepareFileAmlz(idZadosti!, file.fileName ? file.fileName : '', mode === 'smsLogin', idOsoby).then(resp => {
                setDownloading('dokladTotoz');
                fileDownload(
                    resp.redirect,
                    file.name ? file.name : 'file',
                    mode === 'smsLogin' ? 'AMLodkaz/Download' : null
                ).finally(() => setDownloading(''));
            }),
        fileList: dokladyTotozFileList,
        buttonDisabled: dokladyTotozFileList ? dokladyTotozFileList.length > 4 : false
    };

    const RenderKopieDokladouTotoznostiUpload = () => (
        <Form.Item
            id="sc"
            name="sc"
            style={{
                marginBottom: 0,
                position: 'relative',
                top: -8
            }}
            rules={[
                {
                    validator() {
                        try {
                            if (!dokladyTotozFileList?.length)
                                return Promise.reject(<TranslateText>NEVALIDNI_POVINNA_POLOZKA_UPLOAD</TranslateText>);
                            return Promise.resolve();
                        } catch {
                            return Promise.reject();
                        }
                    }
                }
            ]}
        >
            <div
                style={{
                    marginBottom: 22,
                    marginTop: 18
                }}
            >
                <p
                    style={{
                        margin: 6
                    }}
                >
                    <TranslateText>
                        {form.getFieldValue('stav') === EStavZadostAmlz.HOTOVO ||
                        form.getFieldValue('stav') === EStavZadostAmlz.HOTOVOIIS ||
                        form.getFieldValue('stav') === EStavZadostAmlz.CDCPKEKONTR ||
                        mode === 'C2' ||
                        mode === 'zadostEdit'
                            ? 'FORMULARE_DOKLADY_TOTOZNOSTI_DISABLED'
                            : 'FORMULARE_DOKLADY_TOTOZNOSTI'}
                    </TranslateText>
                </p>
                <div>
                    <UploadComponent
                        {...uploadPropsKopieDokladouTotoznosti}
                        showRemoveIcon={
                            !(
                                mode === 'displayOnly' ||
                                identifikaceOsobyElhasFileUploaded ||
                                form.getFieldValue('stav') === EStavZadostAmlz.HOTOVO ||
                                form.getFieldValue('stav') === EStavZadostAmlz.HOTOVOIIS ||
                                form.getFieldValue('stav') === EStavZadostAmlz.CDCPKEKONTR ||
                                ((mode === 'C2' || mode === 'zadostEdit') && !isAmlzRequired)
                            )
                        }
                        hideButton={
                            mode === 'displayOnly' ||
                            identifikaceOsobyElhasFileUploaded ||
                            form.getFieldValue('stav') === EStavZadostAmlz.HOTOVO ||
                            form.getFieldValue('stav') === EStavZadostAmlz.HOTOVOIIS ||
                            form.getFieldValue('stav') === EStavZadostAmlz.CDCPKEKONTR ||
                            ((mode === 'C2' || mode === 'zadostEdit') && !isAmlzRequired)
                        }
                        uploadPath={mode === 'smsLogin' ? apiPaths.FILE_UPLOAD_AMLODKAZ : ''}
                    />
                </div>{' '}
            </div>
        </Form.Item>
    );

    const uploadPropsElektPodpis = {
        id: 'c2ElektPodpisBtn',
        showDownloadIcon: true,
        onChange: (data: UploadChangeParam) => {
            if (data.file.status === 'uploading') setDownloading(EDownloadingStatus.ELEKTPODPIS);
            if (data.file.status !== 'uploading') setDownloading('');
            if (data.fileList)
                setElPodpisFileList([
                    {
                        uid: data.fileList[0].uid,
                        name: data.fileList[0].name,
                        fileName: data.fileList[0].fileName
                            ? data.fileList[0].fileName
                            : data.fileList[0].response
                              ? data.fileList[0].response.tempnazev
                              : '',
                        type: data.fileList[0].type!,
                        size: data.fileList[0].size!,
                        status: data.fileList[0].status ? data.fileList[0].status : 'error'
                    }
                ]);
            if (data.file.response && data.file.response.tempnazev) {
                setPdfCheckError('');
                setElPodpisSoubor([
                    {
                        orignazev: data.file.name,
                        tempnazev: data.file.response.tempnazev,
                        oblast: ETypSouboru.SOUBOR_PODEPSANYSOUBOR
                    }
                ]);
                setElPodpisFileList([
                    {
                        uid: data.fileList[0].uid,
                        name: data.fileList[0].name,
                        fileName: data.fileList[0].fileName
                            ? data.fileList[0].fileName
                            : data.fileList[0].response
                              ? data.fileList[0].response.tempnazev
                              : '',
                        type: data.fileList[0].type!,
                        size: data.fileList[0].size!,
                        status: data.fileList[0].status ? data.fileList[0].status : 'error'
                    }
                ]);
                form.validateFields(['el']);
            }
        },
        onRemove: () => {
            setElPodpisFileList([]);
            setPdfCheckError('');
            setElPodpisSoubor([]);
        },
        onDownload: (file: UploadFile) =>
            prepareFileAmlz(idZadosti!, file.fileName ? file.fileName : '', mode === 'smsLogin', idOsoby).then(resp => {
                setDownloading(EDownloadingStatus.ELEKTPODPIS);
                fileDownload(
                    resp.redirect,
                    file.name ? file.name : 'file',
                    mode === 'smsLogin' ? 'AMLodkaz/Download' : null
                ).finally(() => setDownloading(''));
            }),
        fileList: elPodpisFileList,
        buttonLoading: downloading === EDownloadingStatus.ELEKTPODPIS,
        buttonDisabled: !!elPodpisFileList.length
    };
    const RenderElektPodpisUpload = () => (
        <Form.Item
            id="el"
            name="el"
            style={{
                marginBottom: 0,
                position: 'relative',
                top: -8
            }}
            rules={[
                {
                    validator() {
                        try {
                            if (!elPodpisFileList?.length)
                                return Promise.reject(<TranslateText>NEVALIDNI_POVINNA_POLOZKA_UPLOAD</TranslateText>);
                            return Promise.resolve();
                        } catch {
                            return Promise.reject();
                        }
                    }
                }
            ]}
        >
            <div
                style={{
                    marginBottom: 22
                }}
            >
                <p
                    style={{
                        margin: 6
                    }}
                >
                    <TranslateText>
                        {form.getFieldValue('stav') === EStavZadostAmlz.HOTOVO ||
                        form.getFieldValue('stav') === EStavZadostAmlz.HOTOVOIIS ||
                        mode === 'C2' ||
                        mode === 'zadostEdit'
                            ? 'FORMULARE_PODEPSANY_SOUBOR_DISABLED'
                            : 'FORMULARE_PODEPSANY_SOUBOR'}
                    </TranslateText>
                </p>
                <div>
                    <UploadComponent
                        {...uploadPropsElektPodpis}
                        showRemoveIcon={
                            !(
                                mode === 'displayOnly' ||
                                form.getFieldValue('stav') === EStavZadostAmlz.HOTOVO ||
                                form.getFieldValue('stav') === EStavZadostAmlz.HOTOVOIIS ||
                                form.getFieldValue('stav') === EStavZadostAmlz.CDCPKEKONTR ||
                                ((mode === 'C2' || mode === 'zadostEdit') && !isAmlzRequired)
                            )
                        }
                        hideButton={
                            mode === 'displayOnly' ||
                            form.getFieldValue('stav') === EStavZadostAmlz.HOTOVO ||
                            form.getFieldValue('stav') === EStavZadostAmlz.HOTOVOIIS ||
                            form.getFieldValue('stav') === EStavZadostAmlz.CDCPKEKONTR ||
                            ((mode === 'C2' || mode === 'zadostEdit') && !isAmlzRequired)
                        }
                        uploadPath={mode === 'smsLogin' ? apiPaths.FILE_UPLOAD_AMLODKAZ : ''}
                    />
                </div>
            </div>
        </Form.Item>
    );

    const uploadPropsCert = {
        showDownloadIcon: true,
        fileList: fileList,
        onRemove: () => {
            setPdfCheckError('');
            setFileList([]);
            setCertUploadResp(undefined);
            setShowCertErr(false);
        },
        buttonDisabled: fileList.length > 0,
        onChange: (uplData: UploadChangeParam) => {
            if (uplData.event) {
                setPdfCheckError('');
                setDownloading('cert');
                setShowCertErr(false);
            }
            if (uplData.file.status && uplData.fileList) {
                uplData.fileList.map(e => {
                    setFileList(
                        e.status === 'error'
                            ? []
                            : [
                                  {
                                      uid: e.uid,
                                      name: e.name.normalize(),
                                      fileName: e.fileName ? e.fileName : e.response ? e.response.tempnazev : '',
                                      type: e.type!,
                                      size: e.size!,
                                      status: e.status ? e.status : 'error'
                                  }
                              ]
                    );
                });
            }
            if (uplData.file.response) {
                (mode === 'smsLogin'
                    ? certKontrolaSmsApi(uplData.file.response.tempnazev, idZadosti!, idOsoby!)
                    : certKontrolaApi(uplData.file.response.tempnazev)
                )
                    .then(data => {
                        if (data.message === 'OK') {
                            uplData.fileList.map(e => {
                                setFileList([
                                    {
                                        uid: e.uid,
                                        name: e.name.normalize(),
                                        fileName: e.fileName ? e.fileName : e.response ? e.response.tempnazev : '',
                                        type: e.type!,
                                        size: e.size!,
                                        status: e.status ? e.status : 'error'
                                    }
                                ]);
                            });
                            setCertUploadResp(data);
                            setShowCertErr(false);
                        } else if (data.message === 'NE') {
                            setShowCertErr(true);
                            setTimeout(() => form.validateFields(['tempcert']), 50);
                        }
                        setDownloading('');
                    })
                    .catch(() => {
                        setShowCertErr(true);
                        setTimeout(() => form.validateFields(['tempcert']), 50);
                    });
            }
        },
        buttonLoading: downloading === 'cert'
    };

    return [
        elPodpisSoubor,
        dokladyTotozSoubory,
        zasOsobaSoubory,
        potvrzeniSoubory,
        dokladyTotozFileList,
        elPodpisFileList,
        setElPodpisFileList,
        setElPodpisSoubor,
        uploadPropsCert,
        certUploadResp,
        setCertUploadResp,
        showCertErr,
        downloading,
        setDownloading,
        showIdentifikaceUpload,
        setShowIdentifikaceUpload,
        showZastupujeUpload,
        setShowZastupujeUpload,
        RenderCertUpload,
        RenderElektPodpisUpload,
        RenderKopieDokladouTotoznostiUpload,
        RenderZastupujiciOsobaUpload,
        uploadStateReady,
        identifikaceOsobyElhasFileUploaded,
        fileList,
        setFileList
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ] as const;
};
